module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticStyle: {
      "border-bottom": "1px #CDD2E0 solid !important"
    },
    attrs: {
      "color": "white",
      "app": "",
      "fixed": "",
      "dense": "",
      "prominent": "",
      "flat": "",
      "extension-height": "25px"
    }
  }, [_c('v-toolbar-title', [(_vm.topnav.flag == 1) ? _c('span', {
    class: _vm.topnav.class
  }, [_vm._v("\n        " + _vm._s(_vm.topnav.text) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.topnav.flag == 2) ? _c('img', {
    attrs: {
      "src": require("../assets/images/logo03.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "caption hidden-xs-only grey--text"
  }, [_vm._v(_vm._s(_vm.user.organizationName))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "nav"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "grey--text hidden-md-and-up"
  }, [_vm._v("language")]), _vm._v(" "), _c('div', {
    staticClass: "grey--text hidden-sm-and-down"
  }, [_vm._v("\n          language  (" + _vm._s(_vm.$t("params.label")) + ")  \n          "), _c('i', {
    staticClass: "fa fa-angle-down"
  })])], 1), _vm._v(" "), _vm._l((_vm.supportLanguage), function(label, key) {
    return _c('v-list', {
      key: key
    }, [_c('v-list-tile', {
      on: {
        "click": function($event) {
          _vm.changeLanguage(key)
        }
      }
    }, [_c('span', {
      staticClass: "body-1"
    }, [_vm._v(_vm._s(label))])])], 1)
  })], 2), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey--text",
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("account_circle")]), _vm._v("  \n        "), _c('div', {
    staticClass: "hidden-xs-only"
  }, [_vm._v("\n          " + _vm._s(_vm.user.username) + "  \n          "), _c('role-label', {
    attrs: {
      "role": _vm.user.roles[0]['name']
    }
  }), _vm._v("   \n          "), _c('i', {
    staticClass: "fa fa-angle-down"
  })], 1)], 1), _vm._v(" "), _c('v-list', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Profile'
      }
    }
  }, [_c('v-list-tile', {
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "body-1"
  }, [_vm._v("Profile")])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Usage Report'
      }
    }
  }, [_c('v-list-tile', {
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "body-1"
  }, [_vm._v("Usage Report")])])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.logout
    }
  }, [_c('a', {
    staticClass: "body-1",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Log Out "), _c('i', {
    staticClass: "fa fa-sign-out"
  })])])], 1)], 1)], 1), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "justify-center",
    attrs: {
      "slot": "extension",
      "id": "nav-menu"
    },
    slot: "extension"
  }, _vm._l((_vm.topMenus), function(menu) {
    return _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (menu.show),
        expression: "menu.show"
      }],
      key: menu.to,
      attrs: {
        "flat": "",
        "to": menu.to
      }
    }, [_c('div', [_vm._v("\n       " + _vm._s(menu.label) + "\n     ")])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-06a84f4b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Topnav.vue
// module id = 1904
// module chunks = 0